import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedTeamOptionParentList = ({
  name,
  fullParentNameList
}) => {
  if (fullParentNameList.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Small, {
    children: [...fullParentNameList, name].join(' > ')
  });
};
const SelectedTeamOption = ({
  id,
  name,
  totalTeamMembers,
  fullParentNameList,
  onRemoveTeam,
  userCanRemoveTeam
}) => {
  return /*#__PURE__*/_jsxs(MultiColumnGroup, {
    children: [/*#__PURE__*/_jsx(MultiColumnItem, {
      paddingInlineEnd: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ListsIcon, {
          size: "800"
        }), /*#__PURE__*/_jsxs(View, {
          as: "div",
          marginInlineStart: "600",
          children: [/*#__PURE__*/_jsx(View, {
            as: "div",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ui-asset-management-lib.assetAccessPanel.teamMembers",
              options: {
                teamName: name,
                totalTeamMembers
              }
            })
          }), /*#__PURE__*/_jsx(SelectedTeamOptionParentList, {
            name: name,
            fullParentNameList: fullParentNameList
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(MultiColumnItem, {
      children: userCanRemoveTeam && /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": `remove-team-button-${id}`,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.removeTeam"
        }),
        size: "extra-small",
        use: "transparent",
        onClick: () => onRemoveTeam(id),
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
};
SelectedTeamOption.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  totalTeamMembers: PropTypes.number.isRequired,
  fullParentNameList: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRemoveTeam: PropTypes.func.isRequired,
  userCanRemoveTeam: PropTypes.bool.isRequired
};
export default SelectedTeamOption;